// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bce7dc8b","581":"c1889c86"}[chunkId] + ".chunk.js";
};